import { CONFIG } from 'src/app/_config/config';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/catch';
import { throwError } from 'rxjs';
import { MessageKendoComponent } from 'src/app/_theme/components/message/message-kendo/message-kendo.component';


@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  message: MessageKendoComponent; 
  
  public gateway = this.config.gateway;
  private port = this.gateway.port;
  url= `${this.gateway.urlQuery}/lbw/usuario`;

  constructor (
    private http: HttpClient, 
    private config: CONFIG
  ) {
  
  }

  onGetUser(id: string) {
    return this.http.get(`${this.url}/user/userid/${id}`);
  }

  
}
